import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { PropTypes } from 'prop-types';
import React from 'react';
import { classnames } from 'tailwindcss-classnames';

import { getFormattedDate } from '../../../utils';
import Link from '../../Link';
import TitleLabel from '../../Titles/TitleLabel';

const CardImageBasedSmall = ({
  date: _date,
  franchise,
  header,
  image,
  imageClassName = 'h-32 lgH:h-44 image-hover',
  imageResponsive,
  size = 'small',
  slug,
  tags,
  title,
}) => {
  const headline = header?.headline;

  const titleSpacing = classnames('mt-2', { 'lg:mt-4': headline });

  const date = _date ? getFormattedDate(_date) : false;
  return (
    <div
      className={classnames('flex', 'flex-col', 'overflow-hidden', {
        'lg:h-full': imageResponsive,
      })}
      to={`/article/${slug}/`}
    >
      <Link
        className={classnames({ 'lg:flex-1': imageResponsive }, 'image-hover')}
        to={`/article/${slug}/`}
      >
        <GatsbyImage
          alt={title}
          className={imageClassName}
          image={getImage(image)}
        />
      </Link>
      <div className={titleSpacing}>
        <TitleLabel franchise={franchise} tags={tags} />
      </div>
      <Link
        className={classnames(
          'mt-2',
          'text-hover',
          { 'stink-h4': size === 'medium' },
          { 'stink-h5': size === 'small' },
        )}
        to={`/article/${slug}/`}
      >
        {title}
      </Link>
      {headline && (
        <p className="hidden mt-2 overflow-hidden text-slate stink-body-1 lg:block whitespace-nowrap overflow-ellipsis">
          {headline}
        </p>
      )}

      {date && <p className="mt-2 stink-footnote text-slate">{date}</p>}
    </div>
  );
};

CardImageBasedSmall.propTypes = {
  date: PropTypes.string,
  franchise: PropTypes.object,
  header: PropTypes.object,
  image: PropTypes.object,
  imageClassName: PropTypes.string,
  imageResponsive: PropTypes.bool,
  size: PropTypes.string,
  slug: PropTypes.string,
  tags: PropTypes.array,
  title: PropTypes.string,
};

export default CardImageBasedSmall;
